import benefitsChartInit from "../components/_benefits-chart";

benefitsChartInit();
